import type { Locale } from "@tutor/protocol";

// The family privacy notice is published on the alpha site, next to the app:
// tutor.probabilitylab.org → alpha.probabilitylab.org, tutor-staging → alpha-staging.
// Anything else (local development, previews) links to staging.

const STAGING_SITE = "https://alpha-staging.probabilitylab.org";

export function familyNoticeUrl(
  locale: Locale,
  host: string = typeof location === "undefined" ? "" : location.host,
): string {
  const site =
    host === "tutor.probabilitylab.org" ? "https://alpha.probabilitylab.org" : STAGING_SITE;
  return `${site}/${locale}/privacy/family`;
}
